// src/app/modules/Members/pages/members-table/column-formatters/ActionsColumnFormatter.jsx
import React from "react";
import { Eye, UserX, UserCheck, Trash2, Mail, XCircle } from "lucide-react";

export function ActionsColumnFormatter(
  cellContent,
  row,
  rowIndex,
  { onViewDetails, onEdit, onSuspend, onReactivate, onDelete, onResendInvite, onCancelInvite }
) {
  const isPending = row.status === 'pending';
  const isActive = row.status === 'active';
  const isSuspended = row.status === 'suspended';

  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 6 }}>
      {isPending ? (
        <>
          <ActionBtn onClick={() => onResendInvite(row.membership_id)} title="Resend Invite">
            <Mail size={15} />
          </ActionBtn>
          <ActionBtn onClick={() => onCancelInvite(row.membership_id)} title="Cancel Invite" danger>
            <XCircle size={15} />
          </ActionBtn>
        </>
      ) : (
        <>
          <ActionBtn onClick={() => onViewDetails(row.membership_id)} title="View Profile">
            <Eye size={15} />
          </ActionBtn>

          {isActive && (
            <ActionBtn onClick={() => onSuspend(row.membership_id)} title="Suspend">
              <UserX size={15} />
            </ActionBtn>
          )}

          {isSuspended && (
            <ActionBtn onClick={() => onReactivate(row.membership_id)} title="Reactivate">
              <UserCheck size={15} />
            </ActionBtn>
          )}

          <ActionBtn onClick={() => onDelete(row.membership_id)} title="Remove" danger>
            <Trash2 size={15} />
          </ActionBtn>
        </>
      )}
    </div>
  );
}

function ActionBtn({ onClick, title, children, danger }) {
  return (
    <button
      type="button"
      className={`sety-btn ${danger ? 'sety-btn-danger' : 'sety-btn-ghost'}`}
      style={{ padding: '6px 10px' }}
      onClick={onClick}
      title={title}
    >
      {children}
    </button>
  );
}
